/**
 * Tiny confirmation dialog (no shadcn dependency to keep this isolated).
 */
import { useEffect } from "react";

export default function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  destructive,
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onCancel?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm px-4">
      <div
        data-testid="confirm-dialog"
        className="w-full max-w-md rounded-2xl bg-white shadow-xl p-6"
      >
        <h3 className="font-heading text-lg font-bold tracking-tight text-slate-900">
          {title}
        </h3>
        {description && (
          <p className="mt-2 text-sm text-slate-600">{description}</p>
        )}
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            data-testid="confirm-cancel"
            onClick={onCancel}
            className="rounded-full px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
          >
            {cancelLabel || "Annuler"}
          </button>
          <button
            type="button"
            data-testid="confirm-ok"
            onClick={onConfirm}
            className={`rounded-full px-4 py-2 text-sm font-medium text-white ${
              destructive
                ? "bg-red-600 hover:bg-red-700"
                : "bg-slate-900 hover:bg-slate-800"
            }`}
          >
            {confirmLabel || "Confirmer"}
          </button>
        </div>
      </div>
    </div>
  );
}
